import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-merge-icon',
  imports: [],
  templateUrl: './merge-icon.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './merge-icon.scss',
})
export class MergeIcon {}
